import React, { useState } from 'react';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import { NavLink, useLocation } from 'react-router-dom';
import { HamburgerIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Collapse,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  Icon,
  Image,
  Link,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import { SIDEBARE_HIDDEN_ROUTES } from 'constants/routes';
import AccountMenu from 'components/AccountMenu/AccountMenu';
import IconBox from 'components/IconBox/IconBox';

const state = {};

function SidebarResponsive(props) {
  const [openMenus, setOpenMenus] = useState({});
  let location = useLocation();
  const mainPanel = React.useRef();
  const activeRoute = (routeName) => {
    return location.pathname === routeName;
  };

  const toggleMenu = (routeName) => {
    setOpenMenus((prev) => ({ ...prev, [routeName]: !prev[routeName] }));
  };

  const createLinks = (routes) => {
    // const inactiveBg = useColorModeValue('white', 'gray.700');
    const activeColor = useColorModeValue('gray.700', 'white');
    const inactiveColor = useColorModeValue('gray.400', 'gray.400');

    return routes.map((prop) => {
      if (prop?.redirect || prop?.path?.includes(':') || SIDEBARE_HIDDEN_ROUTES.includes(prop?.path)) {
        return null;
      }
      if (prop?.category) {
        var st = {};

        st[prop['state']] = !state[prop?.state];

        return (
          <div key={prop?.name}>
            <Text
              color={activeColor}
              fontWeight='bold'
              mb={{
                xl: '12px',
              }}
              mx='auto'
              ps={{
                sm: '10px',
                xl: '16px',
              }}
              py='12px'
            >
              {document.documentElement.dir === 'rtl' ? prop.rtlName : prop.name}
            </Text>
            {createLinks(prop.views)}
          </div>
        );
      }

      const hasChildren = prop?.children && prop?.children?.length > 0;
      const isChildActive = hasChildren && prop?.children?.some((child) => activeRoute(child.layout + child.path));
      const isActive = activeRoute(prop.layout + prop.path);

      return (
        <Box key={prop?.name} w='100%'>
          {!hasChildren ? (
            <NavLink to={prop.layout + prop.path} key={prop.name}>
              <Button
                boxSize='initial'
                justifyContent='flex-start'
                alignItems='center'
                bg={isActive ? '#EDF2F6' : 'transparent'}
                mb={{ xl: '12px' }}
                mx={{ xl: 'auto' }}
                ps={{ sm: '10px', xl: '16px' }}
                py='12px'
                borderRadius='10px'
                w='100%'
                _hover='none'
                _active={{
                  bg: 'inherit',
                  transform: 'none',
                  borderColor: 'transparent',
                }}
                _focus={{
                  boxShadow: 'none',
                }}
              >
                <Flex>
                  {typeof prop?.icon === 'string' ? (
                    <Icon>{prop?.icon}</Icon>
                  ) : (
                    <IconBox
                      h='30px'
                      w='30px'
                      me='12px'
                      bg={isActive ? 'black' : 'transparent'}
                      color={isActive ? 'white' : 'black'}
                    >
                      {prop?.icon}
                    </IconBox>
                  )}
                  <Text color={isActive ? activeColor : inactiveColor} my='auto' fontSize='sm'>
                    {prop?.name}
                  </Text>
                  {hasChildren && <Icon as={openMenus[prop.name] ? BiChevronUp : BiChevronDown} ml='auto' />}
                </Flex>
              </Button>
            </NavLink>
          ) : (
            <Button
              boxSize='initial'
              justifyContent='flex-start'
              alignItems='center'
              bg={isChildActive ? '#EDF2F6' : 'transparent'}
              mb={{ xl: '12px' }}
              mx={{ xl: 'auto' }}
              ps={{ sm: '10px', xl: '16px' }}
              py='12px'
              borderRadius='10px'
              w='100%'
              _hover='none'
              _active={{
                bg: 'inherit',
                transform: 'none',
                borderColor: 'transparent',
              }}
              _focus={{
                boxShadow: 'none',
              }}
              onClick={() => toggleMenu(prop?.name)}
            >
              <HStack>
                {typeof prop?.icon === 'string' ? (
                  <Icon>{prop?.icon}</Icon>
                ) : (
                  <IconBox
                    h='30px'
                    w='30px'
                    me='12px'
                    bg={isChildActive ? 'black' : 'transparent'}
                    color={isChildActive ? 'white' : 'black'}
                  >
                    {prop?.icon}
                  </IconBox>
                )}

                <Text color={isChildActive ? activeColor : inactiveColor} my='auto' fontSize='sm'>
                  {prop?.name}
                </Text>
                {hasChildren && (
                  <Icon
                    as={openMenus[prop.name] ? BiChevronUp : BiChevronDown}
                    ml={2}
                    h={6}
                    w={6}
                    color={isChildActive ? 'black' : 'gray.400'}
                  />
                )}
              </HStack>
            </Button>
          )}

          {hasChildren && (
            <Collapse in={openMenus[prop?.name]} animateOpacity>
              <Stack pl={8} spacing={2} my={2}>
                {prop?.children?.map((child) => (
                  <NavLink to={child.layout + child.path} key={child?.name} style={{ width: '100%' }}>
                    <Button
                      key={child?.name}
                      boxSize='initial'
                      justifyContent='flex-start'
                      alignItems='center'
                      bg={activeRoute(child?.layout + child?.path) ? '#EDF2F6' : 'transparent'}
                      mb={{ xl: '12px' }}
                      mx={{ xl: 'auto' }}
                      ps={{ sm: '10px', xl: '16px' }}
                      py='12px'
                      borderRadius='10px'
                      w='100%'
                      _hover='none'
                      _active={{
                        bg: 'inherit',
                        transform: 'none',
                        borderColor: 'transparent',
                      }}
                      _focus={{
                        boxShadow: 'none',
                      }}
                    >
                      <Flex>
                        <Text
                          color={activeRoute(child?.layout + child?.path) ? activeColor : inactiveColor}
                          my='auto'
                          fontSize='sm'
                        >
                          {child?.name}
                        </Text>
                      </Flex>
                    </Button>
                  </NavLink>
                ))}
              </Stack>
            </Collapse>
          )}
        </Box>
      );
    });
  };

  const { logo, routes } = props;

  var links = <>{createLinks(routes)}</>;
  //  BRAND
  //  Chakra Color Mode
  let hamburgerColor = useColorModeValue('gray.500', 'gray.200');

  if (props.secondary === true) {
    hamburgerColor = 'white';
  }
  var brand = (
    <Box pt={'35px'} mb='8px'>
      <Link
        href={`${process.env.PUBLIC_URL}/dashboard`}
        target='_blank'
        display='flex'
        lineHeight='100%'
        fontWeight='bold'
        justifyContent='center'
        alignItems='center'
        fontSize='11px'
        mb={4}
      >
        <Image src={logo} alt='Zamp logo' w='80px' />
      </Link>
    </Box>
  );

  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  return (
    <Flex display={{ sm: 'flex', xl: 'none' }} ref={mainPanel} alignItems='center'>
      <HamburgerIcon cursor='pointer' color={hamburgerColor} w='20px' h='20px' ref={btnRef} onClick={onOpen} />
      <Drawer isOpen={isOpen} onClose={onClose} placement='left' finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent w='280px' maxW='280px' borderRadius='0px 10px 10px 0px'>
          <DrawerCloseButton _focus={{ boxShadow: 'none' }} _hover={{ boxShadow: 'none' }} />
          <DrawerBody maxW='280px' px='1rem'>
            <Flex direction='column' height='100vh'>
              <Box>{brand}</Box>
              <Stack direction='column' flex='1'>
                <Box>{links}</Box>
              </Stack>

              <Box align='center' mt='10px' mb='10px' p='2'>
                <AccountMenu />
              </Box>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}

export default SidebarResponsive;
